export const getHeaderHeight = (defaultHeight = 80) => {
  const header = document.querySelector("header");
  return header?.offsetHeight || defaultHeight;
};

export const scrollToSectionRef = (targetRef) => {
  if (!targetRef?.current) {
    return;
  }

  const headerHeight = getHeaderHeight();
  const elementPosition = targetRef.current.getBoundingClientRect().top;
  const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

  window.scrollTo({
    top: offsetPosition,
    behavior: "smooth",
  });
};

export const buildContactRequestPayload = (values, videoUrl) => ({
  full_name: values.fullName,
  email: values.email,
  subject: values.subject || "",
  message: values.message || "",
  video: videoUrl,
});
